import React from 'react'
import { Button } from 'react-bootstrap'
import "./Button.css"
import { useTranslation } from 'react-i18next'
import { addItem } from '../../Reducers/cartReducer'
import { useDispatch, useSelector } from 'react-redux'

const AddToCartButton = ({ item, setShow }) => {
    const isFull = useSelector(state => state.cart.isFull);
    const dispatch = useDispatch();

    const { t } = useTranslation();

    const addToCart = (e) => {
        e.stopPropagation();
        if (!isFull) {
            dispatch(addItem(item));
            setShow(true);
        }
    }

    return (
        <span className="pull-right ps-3" onClick={(e) => addToCart(e)}>
            <Button variant="primary" size="sm" className={`custom-button ${isFull ? "disabled" : ""}`}>
                <i className="bi bi-cart"></i>
                <span> {t('add_to_cart')}</span>
            </Button>
        </span>
    )
}

export default AddToCartButton